import { clientePedido } from '../../apiClient/index'

let tokenName = 'SistemaPedidoToken'

const moduloSesion = {
  namespaced: true,
  state: {
    verificandoCredenciales: true,
    cerrandoSesion: false,
    autenticando: false,
    resultadoAutenticacion: undefined,
    resultadoTOTP: undefined,
    sesionExpirada: false,
    loading: false,
    validandoTOTP: false,
    guardandoTOTP: false
  },
  actions: {
    verificarCredenciales(context)
    {
      return new Promise((resolve) => {
 
        // obtengo las credeciales desde el local storage del browser
        let token = JSON.parse(localStorage.getItem(tokenName))

        // si no hay un token, retorno
        if(token == null)
        {
          context.commit('setVerificandoCredenciales', false)
          resolve()
          return
        }

        // verifico si la sesión está activa
        let payload = { sesion: token.Sesion }
        clientePedido.post('/api/account/GetCurrentUser', payload)
        .then(response => {

          if(response.data === -1){
            window.localStorage.removeItem(tokenName)
            context.commit('setResultadoAutenticacion', undefined)
          }
          else
          {
            context.commit('setResultadoAutenticacion', token)
          }
          
          context.commit('setVerificandoCredenciales', false)
        })
        .catch(() => {
          window.localStorage.removeItem(tokenName)
          context.commit('setResultadoAutenticacion', undefined)
          context.commit('setVerificandoCredenciales', false)
        })
        .finally(() => { 
          // llamo a la función de callback
          resolve(context.state.resultadoAutenticacion) 
        })
      })
    },

    autenticar(context, payload) 
    {
      return new Promise((resolve) => {
        
        // indico que se está autenticando
        context.commit('setAutenticando', true)
        context.commit('setCerrandoSesion', false)
        context.commit('setVerificandoCredenciales', false)
        
        // autentico el usuario
        clientePedido.post('/api/account/Login', payload)
        .then(response => {

          var resultadoAutenticacion = response.data

          // guardo el resultado de la autenticación
          context.commit('setResultadoAutenticacion', resultadoAutenticacion)

          // si la autenticación fue exitosa, guardo su valor en el local storage del browser
          if(resultadoAutenticacion.EstaAutenticado)
            window.localStorage.setItem(tokenName, JSON.stringify(resultadoAutenticacion))
        }).catch(() =>{
          context.commit('setResultadoAutenticacion', undefined)
        })
        .finally(() => {
          context.commit('setAutenticando', false)
          resolve(context.state.resultadoAutenticacion)
        })
      })
    },

    cerrarSesion(context, payload) {
      
      if(payload === undefined) 
      {
        context.commit('setCerrandoSesion', true)
        const sesionActual = context.state.resultadoAutenticacion && context.state.resultadoAutenticacion.Sesion
        if (!sesionActual) {
          context.commit('setResultadoAutenticacion', undefined)
          window.localStorage.removeItem(tokenName)
          context.commit('setCerrandoSesion', false)
          context.commit('setVerificandoCredenciales', false)
          return Promise.resolve()
        }

        payload = { sesion: sesionActual }
      }
      
      // limpio los datos de la sesión
      context.commit('setResultadoAutenticacion', undefined)
      window.localStorage.removeItem(tokenName)

      return new Promise((resolve) => {
        clientePedido.post('/api/Account/Logout', payload)
        .then(response => {
          resolve(response.data)
        })
        .catch(() => {
          resolve()
        })
        .finally(() => {
          context.commit('setCerrandoSesion', false)
          context.commit('setVerificandoCredenciales', false)
        })
      })
    },

    cambiarContrasenia(context, payload) 
    {
      return new Promise((resolve) => {
        
        // agrego el valor de la sesión al payload
        payload.sesion = context.state.resultadoAutenticacion && context.state.resultadoAutenticacion.Sesion

        if(!payload.sesion) {
          resolve()
          return
        }

        // llamo al servidor
        clientePedido.post('/api/Account/CambiarContrasenia', payload)
        .then(response => {
          resolve(response.data)
        })
        .finally(() => resolve())
      })
    },

    cambiarContraseniaVencida(context, payload) 
    {
      return new Promise((resolve) => {

        context.commit('setLoading', true)
        // llamo al servidor
        clientePedido.post('/api/Account/CambiarContraseniaVencida', payload)
        .then(response => {
          resolve(response.data)
          context.commit('setLoading', false)
        }).catch(() => {
          context.commit('setLoading', false)
        })
        .finally(() => resolve())
      })
    },
    desactivarTOTP(context, payload) {
      return new Promise((resolve) => {
        context.commit('setLoading', true)
        clientePedido.post('/api/Account/DesactivarTOTP', payload)
        .then(response => {
          resolve(response.data)
          context.commit('setLoading', false)
        })
      })
    },

    validarTOTP(context, payload) {
      return new Promise((resolve) => {
        // Indico que se está validando el TOTP
        context.commit('setValidandoTOTP', true);
        clientePedido.post('/api/Account/ValidarCodigoTOTP', payload)
          .then(response => {
            var resultadoTOTP = response.data;
    
            // Almaceno el resultado de la autenticación en el estado
            context.commit('setResultadoTOTP', resultadoTOTP);
    
            if (resultadoTOTP.EstaAutenticado) {
              window.localStorage.setItem(tokenName, JSON.stringify(resultadoTOTP));
            }
    
            context.commit('setValidandoTOTP', false);
            
            // Resuelvo la promesa con el resultado de la autenticación
            resolve(resultadoTOTP);
          })
          .catch(error => {
            context.commit('setValidandoTOTP', false);
            // Verifica si hay una respuesta del error para obtener más detalles
            if (error.response) {
              alert(`Error: ${error.response.data.message || "Error desconocido"}`);
            } else if (error.request) {
              alert("Error: No se recibió respuesta del servidor.");
            } else {
              alert(`Error: ${error.message}`);
            }
          });
      });
    },

    guardarTOTP(context, payload) {
      return new Promise((resolve) => {
        // Indico que se está validando el TOTP
        context.commit('setGuardandoTOTP', true);

        clientePedido.post('/api/Account/GuardarCodigoTOTP', payload)
          .then(response => {
            var guardadoTOTP = response.data;
    
            context.commit('setGuardandoTOTP', false);

            resolve(guardadoTOTP);
          })
          .catch(error => {
            context.commit('setGuardandoTOTP', false);
            // Verifica si hay una respuesta del error para obtener más detalles
            if (error.response) {
              alert(`Error: ${error.response.data.message || "Error desconocido"}`);
            } else if (error.request) {
              alert("Error: No se recibió respuesta del servidor.");
            } else {
              alert(`Error: ${error.message}`);
            }
          });
      });
    },
    
    generarQRCode(context, payload) {
      return new Promise((resolve) => {
        context.commit('setLoading', true)
        clientePedido.post('/api/Account/GenerarQRCode', payload)
        .then(response => {
          resolve(response.data)
          context.commit('setLoading', false)
        })
        .catch(() => {
          context.commit('setLoading', false)
        })
        .finally(() => resolve())
      })
    },

    guardarContrasenia(context, payload) 
    {
      return new Promise((resolve) => {
        context.commit('setLoading', true)
        // llamo al servidor
        clientePedido.post('/api/Account/GuardarContrasenia', payload)
        .then(response => {
          console.log(response)
          resolve(response)
          context.commit('setLoading', false)
        }).catch(() => {
          context.commit('setLoading', false)
        })
        .finally(() => resolve())
      })
    },

    recuperarContrasenia(context, payload) {
      return new Promise((resolve) => {
        
        context.commit('setLoading', true)
        // llamo al servidor
        clientePedido.post('api/Account/RecuperarContrasenia', payload)
        .then(response => {
          resolve(response.data)
          context.commit('setLoading', false)
        }).catch(() => {
          context.commit('setLoading', false)
        })
        .finally(() => resolve())
      })
    },

    restablecerContrasenia(context, payload) {
      return new Promise((resolve) => {
        context.commit('setLoading', true)
        clientePedido.post('api/Account/RestablecerContrasenia', payload)
        .then(response => {
          resolve(response.data)
          context.commit('setLoading', false)
        })
        .catch(() => {
          context.commit('setLoading', false)
        })
        .finally(() => resolve())
      })
    },
    getDatosUsuario(context, usuarioId) {
      return new Promise((resolve, reject) => {
        if(!usuarioId) {
          console.error("El id del usuario no se pudo encontrar");
          reject();
        }
        clientePedido.get('api/Account/GetDatosUsuario', {params: {usuarioId: usuarioId}})
        .then(response => {
          resolve(response.data)
        })
        .catch(() => {
          
        })
        .finally(() => resolve())
      })
    }
  },
  mutations: {
    setVerificandoCredenciales(state, payload)
    {
      state.verificandoCredenciales = payload
    },

    setCerrandoSesion(state, payload) 
    {
      state.cerrandoSesion = payload
    },

    setAutenticando(state, payload)
    {
      state.autenticando = payload
    },

    setResultadoAutenticacion(state, payload)
    {
      state.resultadoAutenticacion = payload
    },

    setResultadoTOTP(state, payload) {
      state.resultadoTOTP = payload;
    },

    setLoading(state, payload)
    {
      state.loading = payload
    },

    setValidandoTOTP(state, payload)
    {
      state.validandoTOTP = payload
    },

    setGuardandoTOTP(state, payload)
    {
      state.guardadoTOTP = payload
    },


    setSesionExpirada(state, payload) 
    {
      state.sesionExpirada = payload
    }
  },

  getters: {
    getPermisos(state) {
      let permisosVisuales = []

      if(state.resultadoAutenticacion !== undefined && state.resultadoAutenticacion.PermisosVisuales !== undefined)
      {
        permisosVisuales = state.resultadoAutenticacion.PermisosVisuales
      }

      return permisosVisuales
    }
  }
}

export default moduloSesion